// src/shared/components/header.jsx
import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import "./header.css";

export default function Header() {
  const { isAuth, user } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <header className="rm-header">
      <div className="container rm-header__inner">
        <Link to="/" className="rm-logo">RecoMeds</Link>

        <button className="rm-burger" aria-label="Abrir menú" onClick={() => setOpen(!open)}>
          <span /><span /><span />
        </button>

        <nav className={`rm-nav ${open ? "is-open" : ""}`} onClick={() => setOpen(false)}>
          <NavLink exact to="/" activeClassName="active">Inicio</NavLink>
          <NavLink exact to="/buscar" activeClassName="active">Buscar</NavLink>
          <NavLink exact to="/favoritos" activeClassName="active">Favoritos</NavLink>

          {isAuth ? (
            <>
              <NavLink exact to="/perfil" className="rm-btn" activeClassName="active">
                {user?.nombreUsuario || "Mi perfil"}
              </NavLink>
            </>
          ) : (
            <>
              <NavLink exact to="/login" className="rm-btn" activeClassName="active">
                Iniciar sesión
              </NavLink>
                          
              <NavLink exact to="/registro" className="rm-btn" activeClassName="active">
                Crear cuenta
              </NavLink>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
